<!--eslint-disable no-mixed-spaces-and-tabs-->
<template>
    <nav
        class="navbar navbar-expand-lg navbar-landing navbar-light fixed-top p-0"
        :style="`background-color: ${!index ? 'white' : '' }`"
        id="navbar"
    >
        <BContainer>
            <router-link
                class="navbar-brand my-3"
                :to="city ? `/${city}` : ''"
            >
                <img
                    src="@/assets/images/logo-libertas.png"
                    class="card-logo card-logo-dark"
                    alt="logo dark"
                    height="30"
                >
                <img
                    src="@/assets/images/libertas-dark.svg"
                    class="card-logo card-logo-light"
                    alt="logo light"
                    height="30"
                >
            </router-link>
            <BButton
                class="navbar-toggler py-0 fs-20 text-body"
                type="button"
                v-b-toggle.navbarSupportedContent
            >
                <i class="mdi mdi-menu"></i>
            </BButton>

            <BCollapse
                class="navbar-collapse"
                id="navbarSupportedContent"
            >
                <ul
                    v-if="index"
                    class="navbar-nav mx-auto mt-2 mt-lg-0"
                    id="navbar-example"
                >
                    <li class="nav-item">
                        <BLink
                            class="nav-link"
                            href="#hero"
                            @click.prevent="scrollToSection('hero')"
                        >
                            Home
                        </BLink>
                    </li>
                    <li class="nav-item">
                        <BLink
                            class="nav-link"
                            href="#wallet"
                            @click.prevent="scrollToSection('marketplace')"
                        >
                            Sobre
                        </BLink>
                    </li>
                    <li class="nav-item">
                        <BLink
                            class="nav-link"
                            href="#categories"
                            @click.prevent="scrollToSection('categories')"
                        >
                            Vagas
                        </BLink>
                    </li>
                    <li class="nav-item">
                        <BLink
                            class="nav-link"
                            href="#steps"
                            @click.prevent="scrollToSection('steps')"
                        >
                            Etapas
                        </BLink>
                    </li>
                    <!--                    <li class="nav-item">-->
                    <!--                        <BLink class="nav-link" href="#numbers" @click.prevent="scrollToSection('numbers')">-->
                    <!--                            Números-->
                    <!--                        </BLink>-->
                    <!--                    </li>-->
                    <li class="nav-item">
                        <BLink
                            class="nav-link"
                            href="#testimonials"
                            @click.prevent="scrollToSection('testimonials')"
                        >
                            Depoimentos
                        </BLink>
                    </li>

                    <li class="nav-item">
                        <router-link
                            to="/duvidas"
                            class="nav-link"
                        >
                            Dúvidas
                        </router-link>
                    </li>
                    <li
                        class="nav-item"
                        v-if="user"
                        @click="getHref()"
                    >
                        <a
                            class="nav-link"
                            :href="href"
                            target="_blank"
                        >
                            Cursos
                        </a>
                    </li>
                </ul>

                <ul
                    v-else
                    class="navbar-nav mx-auto mt-2 mt-lg-0"
                    id="navbar-example"
                >
                    <li class="nav-item">
                        <router-link
                            class="nav-link"
                            :to="city ? `/${city}` : '/'"
                            style="color: #272a3a"
                        >
                            Home
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link
                            to="/vagas"
                            class="nav-link"
                        >
                            Vagas
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link
                            to="/duvidas"
                            class="nav-link"
                        >
                            Dúvidas
                        </router-link>
                    </li>
                    <li
                        class="nav-item"
                        v-if="user"
                        @click="getHref()"
                    >
                        <a
                            class="nav-link"
                            :href="href"
                            target="_blank"
                        >
                            Cursos
                        </a>
                    </li>
                </ul>

                <div
                    class="mb-3"
                    v-if="!user"
                >
                    <BLink
                        class="btn btn-primary"
                        @click="openWindow('login/public')"
                    >Entrar
                    </BLink>
                    <BLink
                        class="btn btn-secondary ms-2"
                        @click="openWindow('cadastrar')"
                    >Cadastrar
                    </BLink>
                </div>

                <div
                    v-else
                    class="dropdown ms-sm-3 header-item"
                >
                    <button
                        type="button"
                        class="btn"
                        id="page-header-user-dropdown"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span class="d-flex align-items-center">
                            <img
                                v-if="user.img"
                                class="rounded-circle header-profile-user"
                                :src="`${env.url}uploads/candidate-perfil/${user.img}`"
                                alt="Header Avatar"
                            />
                            <img
                                v-else
                                class="rounded-circle header-profile-user"
                                src="@/assets/images/user.jpg"
                                alt="Header Avatar"
                            />
                            <span class="text-start ms-xl-2">
                                <span class="text-secondary ms-1 fw-medium user-name-text">{{
                                        user.name
                                                                                           }}
                                </span>
                            </span>
                        </span>
                    </button>
                    <div
                        class="dropdown-menu dropdown-menu-end"
                        style="top: 70px"
                    >
                        <h6 class="dropdown-header">Bem vindo {{ user.name }}!</h6>

                        <router-link
                            class="dropdown-item"
                            to="/minhas-vagas"
                        >
                            <i class="mdi mdi-speedometer text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Minhas Vagas</span>
                        </router-link>

                        <a
                            @click="getHref()"
                            target="_blank"
                            class="dropdown-item"
                            :href="href"
                        >
                            <i class="mdi mdi-school-outline text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Meus Cursos</span>
                        </a>

                        <router-link
                            class="dropdown-item"
                            to="/meu-perfil"
                        >
                            <i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Meu Perfil</span>
                        </router-link>

                        <b-link
                            class="dropdown-item"
                            @click="logout"
                        >
                            <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span
                                class="align-middle"
                                data-key="t-logout"
                            >Sair
                            </span>
                        </b-link>
                    </div>
                </div>
            </BCollapse>

        </BContainer>
    </nav>
</template>

<script setup>

import {computed, onMounted, ref, onUnmounted, watch} from "vue";
import {useRoute} from "vue-router";
import store from "@/state/store";
import env from '@/env'
import http from "@/http";

const route = useRoute();
const user = computed(() => store.state.auth.currentUser);
const index = ref(true);
const href = ref('#');
const city = sessionStorage.getItem('city');

watch(() => user.value, (newValue) => {
    if (newValue) getHref();
})

function getHref() {
    http.get('login-moodle')
        .then(response => {
            if (response.data && response.data.link) {
                href.value = response.data.link;
            }
        })
}

function scrollToSection(sectionId) {
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({behavior: 'smooth'});
    }
}

function logout() {
    store.dispatch('auth/logout');
}

function openWindow(url) {

    const origin = window.location.origin;

    const left = (window.screen.width / 2) - (500 / 2);
    const top = (window.screen.height / 2) - (800 / 2);

    let newWindow = '';

    if (route.name === 'vacancy-details') {
        const id = route.params.id;
        url += `?selective_process=${id}`;
    }

    if (url.indexOf('login/public') > -1) {
        newWindow = window.open(
            `${origin}/${url}`,
            '_blank',
            `toolbar=yes,scrollbars=yes,resizable=yes,width=500,height=800,top=${top},left=${left}`);
    } else {
        newWindow = window.open(
            `${origin}/${url}`,
            '_blank'
        )
    }

    if (newWindow) {
        newWindow.focus();
    }
}

function handleScroll(ev) {
    ev.preventDefault();
    var navbar = document.getElementById("navbar");
    if (navbar) {
        if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
            navbar.classList.add("is-sticky");
        } else {
            navbar.classList.remove("is-sticky");
        }
    }
}

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
})

onMounted(() => {
    index.value = route.name === 'landing-page';
    var navbar = document.getElementById("navbar");

    if (index.value) {
        if (navbar) {
            navbar.classList.remove("is-sticky");
        }
        window.addEventListener('scroll', handleScroll);
    } else {
        window.removeEventListener('scroll', handleScroll);
        if (navbar) {
            navbar.classList.add("is-sticky");
        }
    }

    const token = localStorage.getItem('token');

    if (token && !user.value) store.dispatch('auth/refresh');
})

</script>
